import { makeStyles } from 'src/utils/makeStyles';

export default makeStyles({
  fieldInput: {
    '& input': {
      fontFamily: 'Roboto Mono',
    },
  },
});
